// LiveStreamChatroomMessage.js
import { connect } from 'react-redux';

import LiveStreamChatroomMessage from '../component/LiveStreamChatroomMessage.jsx';

import fetchUser from '../action/fetchUser.js';
import openBlockUserModal from '../action/openBlockUserModal.js';
import toggleModal from '../action/toggleModal.js';

import getMeData from '../selector/getMeData.js';
import getUserData from '../selector/getUserData.js';
import getRankInLiveStream from '../selector/getRankInLiveStream.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getModalData from '../selector/getModalData.js';
import getOperationData from '../selector/getOperationData.js';
import getVipLevelLivestreamChatStyle from '../selector/getVipLevelLivestreamChatStyle.js';

import {
  FEATURE_DISPLAY_NAME,
  FEATURE_MINI_PROFILE,
  LIVESTREAM_RATING_QUANTIZATION_STEP_SIZE,
} from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { chatMessageId, streamId }) => {
  const meId = getMeData(state, 'id');
  const senderId = getLiveStreamData(
    state,
    [streamId, 'chat', chatMessageId],
    'senderId'
  );
  const sessionId = getLiveStreamData(state, [streamId], 'sessionId');

  let senderUsername = '';
  let senderDisplayName = '';
  if (senderId === meId) {
    senderUsername = getMeData(state, 'username');
    senderDisplayName = getMeData(state, 'displayName');
  } else {
    senderUsername = getUserData(state, senderId, 'username');
    senderDisplayName = getUserData(state, senderId, 'displayName');
  }

  const isMiniBadgeInfoOpen = ['opening', 'display'].includes(
    getModalData(state, 'MiniBadgeInfoModal', 'status')
  );
  const isMiniProfileEnabled =
    getRemoteConfigData(state, FEATURE_MINI_PROFILE) === 1;
  const isDisplayNameEnabled =
    getRemoteConfigData(state, FEATURE_DISPLAY_NAME) === 1;
  const isStreamOwnerMessage = senderId === streamId;
  const isStreamOwner = meId === streamId;
  const rank = getRankInLiveStream(state, streamId, sessionId, senderId);

  const type = getLiveStreamData(
    state,
    [streamId, 'chat', chatMessageId],
    'type'
  );
  const text = getLiveStreamData(
    state,
    [streamId, 'chat', chatMessageId],
    'text'
  );
  const giftName = getLiveStreamData(
    state,
    [streamId, 'chat', chatMessageId],
    'giftName'
  );
  const giftKey = getLiveStreamData(
    state,
    [streamId, 'chat', chatMessageId],
    'giftKey'
  );
  const giftPrice = getLiveStreamData(
    state,
    [streamId, 'chat', chatMessageId],
    'giftPrice'
  );
  const giftDuration = getLiveStreamData(
    state,
    [streamId, 'chat', chatMessageId],
    'giftDuration'
  );
  const amount = getLiveStreamData(
    state,
    [streamId, 'chat', chatMessageId],
    'amount'
  );
  const diamonds = getLiveStreamData(
    state,
    [streamId, 'chat', chatMessageId],
    'diamonds'
  );
  const senderAvatarId = getLiveStreamData(
    state,
    [streamId, 'chat', chatMessageId],
    'senderAvatarId'
  );
  const senderLevel = getLiveStreamData(
    state,
    [streamId, 'chat', chatMessageId],
    'senderLevel'
  );
  const productId = getLiveStreamData(
    state,
    [streamId, 'chat', chatMessageId],
    'productId'
  );
  const senderBadges = getLiveStreamData(
    state,
    [streamId, 'chat', chatMessageId],
    'senderBadges'
  );
  const vipChatStyle = getVipLevelLivestreamChatStyle(state, senderLevel);
  const ratingStepSize = getRemoteConfigData(
    state,
    LIVESTREAM_RATING_QUANTIZATION_STEP_SIZE
  );

  return {
    streamId,
    senderId,
    senderUsername,
    senderDisplayName,
    isStreamOwnerMessage,
    isDisplayNameEnabled,
    isMiniProfileEnabled,
    isMiniBadgeInfoOpen,
    rank,
    type,
    text,
    giftName,
    giftKey,
    giftPrice,
    giftDuration,
    amount,
    diamonds,
    isStreamOwner,
    senderAvatarId,
    senderLevel,
    productId,
    senderBadges,
    vipChatStyle,
    deviceWidth: getOperationData(state, ['device'], 'width'),
    ratingStepSize,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    openBlockUserModal: ({ userId }) =>
      dispatch(openBlockUserModal({ userId })),
    fetchUser: ({ senderId }) => dispatch(fetchUser({ id: senderId })),
    toggleModal: payload => dispatch(toggleModal(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamChatroomMessage);
